<script>
import ModuleTitle from '../common/ModuleTitle.vue'

import { getShadowColor } from '@/utils/modules/getStyles'
import { filtersRichtext, textLenHandler, changeSeconds } from '@/utils/common'

export default {
  name: 'Comp47',
  components: { ModuleTitle },
  props: {
    moduleOption: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      path: this.$route.path
    }
  },
  methods: {
    getShadowColor, filtersRichtext, textLenHandler, changeSeconds
  }
}
</script>

<template>
  <div class="modules-id-47">
    <module-title :title="moduleOption.title" margin-bottom="30" />
    <div class="comp-transverse-2 modules-id-47-content">
      <div
        v-for="(v, i) in moduleOption.list.slice(0, 3)"
        :key="`modules-id-47-item-${i}`"
        class="item"
      >
        <div class="img-box">
          <el-image class="item-img" :src="v.photo | imgPath" alt="cover" fit="cover" />
        </div>
        <div class="item-info">
          <div class="info-left">
            <p class="headline h-line-1">{{ v.headline || '' }}</p>
            <p class="time">时长: {{ changeSeconds(v.time, 'str') }}</p>
          </div>
          <el-image class="info-logo" :src="require('imgs/modules/video-play.png')" alt="cover" fit="cover" />
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.modules-id-47-content {
  display: flex;
  box-sizing: border-box;
  column-gap: 35px;
  .item {
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    .img-box {
      width: 195px;
      height: 245px;
      border-radius: 6px;
      border: 3px solid #2C99B2;
      position: relative;
      .item-img {
        width: 195px;
        height: 245px;
        border-radius: 5px;
        position: absolute;
        top: 6px;
        left: 6px;
      }
    }
    .item-info {
      width: 200px;
      margin: 24px 0 0 6px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .info-left {
        .headline {
          width: 160px;
          font-size: 17px;
          font-weight: 800;
          color: #000;
        }
        .time {
          font-size: 14px;
          font-weight: 500;
          color: #000;
        }
      }
      .info-logo {
        width: 26px;
        height: 26px;
      }
    }
  }
}
</style>
